import { Component, ElementRef, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { CargoSpace, WorkSpace, WorkSpaceStop } from '../../core/types';
import { ProjectService } from '../../core/services/project.service';
import { Project } from '../../core/objects/project';
import { ProjectApiService } from '../../core/services/project-api.service';

@Component({
    selector: 'gl-complete-location-data-popup',
    templateUrl: './complete-location-data-popup.component.html',
    styleUrls: ['./complete-location-data-popup.component.scss'],
    standalone: false
})
export class CompleteLocationDataPopupComponent implements OnInit {
  public currentLang: string = this.translate.currentLang;
  public currentWorkSpace: number;
  public savedStops: WorkSpaceStop[];
  public currentWorkSpaceId: number;
  private loadingSpace: CargoSpace;
  private project: Project;

  constructor(
    private modalRef: ModalOverlayRef,
    private translate: TranslateService,
    private elRef: ElementRef<HTMLElement>,
    private projectService: ProjectService,
    private projectApi: ProjectApiService,
  ) {}

  public closeModal(): void {
    this.modalRef.close('close');
  }

  private getProject(): void {
    this.projectService.project.subscribe((project: Project): void => {
      this.project = project;
      this.getLoadingSpace(project);
      this.currentWorkSpaceId = project.workSpaces[0].id;
      const workSpace: WorkSpace = project.workSpaces[0];
      if (workSpace?.stops?.length > 0) {
        const stops: WorkSpaceStop[] = workSpace.stops.map((stop: WorkSpace) => {
          return {
            id: stop.id,
            name: stop.name,
            city: stop.city,
            country: stop.country,
            postalCode: stop.postalCode,
            address: stop.address,
          };
        });
        this.savedStops = stops;
      }
    });
  }

  public getPosition(): DOMRect {
    return this.elRef.nativeElement.getBoundingClientRect();
  }

  private getLoadingSpace(project: Project): void {
    const loadingSpace: any = project.workSpaces[0].cargoSpaces[0];
    this.loadingSpace = loadingSpace;
  }

  public submitStops(stops: WorkSpaceStop[]): void {
    this.savedStops = stops;
    const loadingSpaceAdd = {
      currentWorkSpaceId: this.currentWorkSpaceId,
      loadingSpace: {
        ...this.loadingSpace,
        ...this.loadingSpace.dimensions,
        set: this.project.workSpaces[0].cargoSpaces.length > 1,
      },
      stops: this.savedStops,
      target: {
        workSpaceId: this.currentWorkSpaceId,
      },
    };
    this.projectApi.updateLoadingSpace(loadingSpaceAdd).subscribe((): void => {
      this.modalRef.close('afterUpdate');
    });
  }

  ngOnInit(): void {
    this.getProject();
  }
}
